import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["indicatorSize", "size", "role", "ariaValueText"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds";
import { LoadingIndicatorCircle } from "./LoadingIndicatorCircle";
import { LoadingIndicatorSvg } from "./LoadingIndicatorSvg";
var indicatorSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
function LoadingIndicatorComponent(_ref) {
  var indicatorSize = _ref.indicatorSize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'progressbar' : _ref$role,
    _ref$ariaValueText = _ref.ariaValueText,
    ariaValueText = _ref$ariaValueText === void 0 ? 'Loading' : _ref$ariaValueText,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LoadingIndicatorSvg, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1 100",
    xmlSpace: "preserve",
    indicatorSize: indicatorSize || size,
    role: role,
    "aria-valuetext": ariaValueText
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.LoadingIndicator
  }), /*#__PURE__*/React.createElement(LoadingIndicatorCircle, {
    stroke: "none",
    cx: "-140",
    cy: "50",
    r: "32"
  }), /*#__PURE__*/React.createElement(LoadingIndicatorCircle, {
    stroke: "none",
    cx: "0",
    cy: "50",
    r: "32"
  }), /*#__PURE__*/React.createElement(LoadingIndicatorCircle, {
    stroke: "none",
    cx: "140",
    cy: "50",
    r: "32"
  }));
}

/**
* **LoadingIndicator** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/LoadingIndicator) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:1596)
*
* LoadingIndicator is used to help end users understand the app is waiting for a response or loading data from the server.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/indicators)
*
* @example
* () => <LoadingIndicator />;
*
*/
export var LoadingIndicator = Object.assign(LoadingIndicatorComponent, indicatorSizes);